import Vue from 'vue';
import { Chrome } from 'vue-color';

Vue.component('color-picker', Chrome);
